export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fcf6b38334ec8d46eb82dffbfef917cc257729edc&name=fetchTypeahead!'